import type { ThemeStringsConfig } from "../../../types/3d";

export const wizardLabStrings: ThemeStringsConfig = {
  authorName: "Manuel Maiuolo",
  siteTitle: "Magic Portfolio",
  siteSubtitle: "Interactive 3D Experience",
  themeTitle: "Wizard Laboratory",
  themeSubtitle: "Interactive 3D Portfolio",
  aboutPrompt: "Discover the wizard behind the lab",
  loadingStatus: "Preloading 3D models",
  readyStatus: "3D laboratory ready",
  enterButton: "Enter Laboratory",
  exploreHint: "Continue reading or enter whenever you're ready",
  objectSearchPrompt: "Search for the {object} in the laboratory!",
  artifactsHeader: "Interactive Artifacts",
  aboutModalTitle: "About the Wizard",
};

export default wizardLabStrings;
